define('view/controller/medical-test/MedicalTestCheckView',['require','lib/view/LayoutView'],function (require) {

	var Parent = require('lib/view/LayoutView');
	
	/**
	 * Medical test check view
	 * 
	 * @class MedicalTestCheckView
	 */
	return Parent.extend({

		template: '#medical_test_check_view',
        
        modelEvents: {
            'sync': 'render'
        },
        
        onDomRefresh: function () {
			this.onShowPage();
		},

		onShowPage: function () {
			Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
				'page': 'medical_test'
			});
		}

	});
	
});
